import {
  PostOnboardingParseBody,
  PostOnboardingParseResponse,
} from '@intelligent-play-v2/domain';
import { queryBuilder } from '~/api';

/**
 * Turn a raw `New_Forms` paste into a reviewable draft. Writes nothing — all the mapping
 * lives server-side so the parity fixtures cover it.
 */
export const postOnboardingParse = async (
  body: PostOnboardingParseBody
): Promise<PostOnboardingParseResponse> => {
  const { data } = await queryBuilder(
    'POST',
    'onboarding/parse',
    undefined,
    body
  );
  return data;
};
